import { useGameStore } from '../store';
import { AD_DAILY_MAX } from '../constants';

export default function TradePanel() {
  const position    = useGameStore((s) => s.position);
  const cash        = useGameStore((s) => s.cash);
  const presets     = useGameStore((s) => s.presets);
  const presetIdx   = useGameStore((s) => s.presetIdx);
  const cooldown    = useGameStore((s) => s.cooldown);
  const boostActive = useGameStore((s) => s.boostActive);
  const adCount     = useGameStore((s) => s.adCount);

  const doBuy        = useGameStore((s) => s.doBuy);
  const doSell       = useGameStore((s) => s.doSell);
  const selectPreset = useGameStore((s) => s.selectPreset);
  const openAd       = useGameStore((s) => s.openAd);
  const openBoostAd  = useGameStore((s) => s.openBoostAd);
  const openDebtAd   = useGameStore((s) => s.openDebtAd);
  const tutStep      = useGameStore((s) => s.tutStep);

  const hasPos      = !!position;
  const adRemain    = Math.max(AD_DAILY_MAX - adCount, 0);
  const adExhausted = adRemain <= 0;
  const hasDebt     = !hasPos && cash < 0;

  return (
    <div id="trade-panel">
      {boostActive && (
        <div id="boost-indicator" className="visible">
          🃏 점쟁이 점지 활성 — 수익 ×2 / 손실 ×0.5
        </div>
      )}

      {!hasPos && (
        <div id="action-row">
          <button
            id="boost-btn"
            disabled={boostActive}
            onClick={openBoostAd}
          >
            🃏 점쟁이 점지받기
          </button>
          {hasDebt && (
            <button id="debt-btn" onClick={openDebtAd}>
              💸 변제받기
            </button>
          )}
          <button
            id="ad-btn"
            disabled={adExhausted}
            onClick={openAd}
          >
            사또 청원 ({adRemain}회)
          </button>
        </div>
      )}

      {!hasPos && (
        <div id="preset-row">
          {([0, 1, 2, 3] as const).map((i) => (
            <button
              key={i}
              className={`preset-btn${presetIdx === i ? ' active' : ''}`}
              onClick={() => selectPreset(i)}
            >
              {i < 3 ? `${presets[i as 0 | 1 | 2]}%` : '지정'}
            </button>
          ))}
        </div>
      )}

      {hasPos ? (
        <button
          id="sell-btn"
          className={tutStep === 2 ? 'pulse-sell' : undefined}
          onClick={doSell}
        >
          물량풀기 (전량)
        </button>
      ) : (
        <button
          id="buy-btn"
          className={tutStep === 1 ? 'pulse-buy' : undefined}
          disabled={cash <= 0 || cooldown}
          onClick={doBuy}
        >
          사재기
        </button>
      )}
    </div>
  );
}
